
import { useEffect } from "react";

export function MobileViewportMeta() {
  useEffect(() => {
    // Set proper viewport meta tag for mobile
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    
    if (!viewportMeta) {
      viewportMeta = document.createElement('meta');
      viewportMeta.setAttribute('name', 'viewport');
      document.head.appendChild(viewportMeta);
    }
    
    viewportMeta.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
    );

    // Add mobile-specific meta tags
    const mobileWebAppCapable = document.createElement('meta');
    mobileWebAppCapable.setAttribute('name', 'mobile-web-app-capable');
    mobileWebAppCapable.setAttribute('content', 'yes');
    document.head.appendChild(mobileWebAppCapable);

    const appleWebAppCapable = document.createElement('meta');
    appleWebAppCapable.setAttribute('name', 'apple-mobile-web-app-capable');
    appleWebAppCapable.setAttribute('content', 'yes');
    document.head.appendChild(appleWebAppCapable);

    const appleWebAppStatusBar = document.createElement('meta');
    appleWebAppStatusBar.setAttribute('name', 'apple-mobile-web-app-status-bar-style');
    appleWebAppStatusBar.setAttribute('content', 'default');
    document.head.appendChild(appleWebAppStatusBar);

    // Cleanup function
    return () => {
      // Remove added meta tags on unmount
      mobileWebAppCapable.remove();
      appleWebAppCapable.remove();
      appleWebAppStatusBar.remove();
    };
  }, []);

  return null;
}
